import React from 'react';
import { Container, Grid } from '@tq/ui-components';

import { TeamTable } from 'components';
import { TeamFilters } from './components/TeamFilters';
import { useManageTeamColumns } from './hooks/useManageTeamColumns';
import { useGetManageTeamRecords } from '../../hooks';

import {
  manageTeamPageNumberState,
  manageTeamPageSizeState,
  manageTeamSortByDescendingFilterState,
  manageTeamSortByColumnFilterState,
  teamEditingRowIdState,
} from 'store';

export const ManageTeams: React.FC = () => {
  const { data, paginationInfo } = useGetManageTeamRecords();
  const columns = useManageTeamColumns();

  return (
    <Container px={{ base: 0, lg: 4, xl: 0 }}>
      <Grid gridGap={2} mb='3rem'>
        <TeamFilters />
        <TeamTable
          teams={data}
          pagination={paginationInfo}
          pageNumberState={manageTeamPageNumberState}
          pageSizeState={manageTeamPageSizeState}
          columns={columns}
          sortByColumnState={manageTeamSortByColumnFilterState}
          sortByDescendingState={manageTeamSortByDescendingFilterState}
          editingState={teamEditingRowIdState}
        />
      </Grid>
    </Container>
  );
};
